import * as React from "react";

const SvgIcnHoldLarge = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width="1em" height="1em" viewBox="0 0 24 24" {...props}>
        <g stroke="currentColor" strokeWidth={1.3} fill="none" fillRule="evenodd">
            <rect x={4.65} y={3.65} width={4.7} height={16.7} rx={1} />
            <rect x={13.65} y={3.65} width={4.7} height={16.7} rx={1} />
        </g>
    </svg>
);

export default SvgIcnHoldLarge;
